$(document).ready(function() {
  if ($('#hamburger')) {
    $('#hamburger').on('click', function(){
      $('.list-horizontal.menu-header').toggleClass('active');
    });
  }
});